import React, { useEffect, useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faTruck } from "@fortawesome/free-solid-svg-icons";
import { useUnidades } from "../../../hooks/test/useUnidades";
import Swal from "sweetalert2";
import { SocketContext } from "../../../context/SocketContext";
import { Spinner } from "../../Spinner";

import { FormularioBitacoraGeneral } from "../../EnRuta/forms/FormularioBitacoraGeneral";
import { formatDate } from "../../../helpers/formatDate";

export const FormatoRegreso = ({
  unidad,
  viaje,
  getUnidades = () => {},
  hideSidebar = () => {},
}) => {
  const { socket } = useContext(SocketContext);
  const { getBitacoraViaje, postBitacora, putViajeStatusV2, getOperadorViaje } =
    useUnidades();
  const [bitacora, setBitacora] = useState([]);
  const [loading, setLoading] = useState(false);
  const [operador, setOperador] = useState({});
  useEffect(() => {
    if (!viaje.viaje_id) return;
    getInfo(viaje.viaje_id);
  }, [viaje]);
  const getInfo = async (viaje_id) => {
    setLoading(true);
    let resp = await getBitacoraViaje(viaje_id);
    if (resp.ok) setBitacora([...resp.bitacora]);
    resp = await getOperadorViaje(viaje_id);
    if (resp.ok) setOperador(resp);

    setLoading(false);
  };
  const liberarUnidad = async () => {
    let resp = await postBitacora({
      id_viaje: viaje.viaje_id,
      notas: "La unidad fue liberada",
      id_status: 8,
    });

    resp = await putViajeStatusV2(viaje.viaje_id, 8);
    if (!resp.ok)
      Swal.fire({
        title: "No se pudo liberar la unidad",
        text: resp.msg,
        icon: "error",
      });
    hideSidebar();
    Swal.fire({
      title: "Unidad liberada",
      text: "La unidad ha sido liberada",
      icon: "success",
    });
    
    socket.emit("traer-unidades-en-ruta_", { idNegocio: unidad.negocio_id});

    hideSidebar();
  };

  return (
    <>
      {loading && <Spinner />}
      <div>
        <div className="card-header" id="card-header">
          {unidad.unidad_numero} (DE REGRESO A{" "}
          {unidad.cat_tipos_almacen
            ? unidad.cat_tipos_almacen.nombre
            : "Almacén"}
          )
          <i className="icono-cerrar">
            <FontAwesomeIcon onClick={hideSidebar} icon={faXmark} />
          </i>
        </div>
        <div className="card-body">
          <button
            id="liberarUnidad"
            onClick={() => {
              Swal.fire({
                title: "¿Deseas liberar unidad?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "¡Si!",
                cancelButtonText: "No",
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) return liberarUnidad();
              });
            }}
            className="btn btn-warning btn-block mb-4"
            disabled={loading}
          >
            <FontAwesomeIcon icon={faTruck} /> &nbsp; Liberar Unidad
          </button>
          <FormularioBitacoraGeneral
            viaje_id={viaje.viaje_id}
            numeroUnidad={unidad.unidad_numero}
            negocioId={unidad.negocio_id}
            getUnidades={() => {
              getUnidades();
            }}
            getBitacora={async () => {
              let resp = await getBitacoraViaje(viaje.viaje_id);
              if (resp.ok) setBitacora(resp.bitacora);
            }}
            close={hideSidebar}
          ></FormularioBitacoraGeneral>
          <div className="row" style={{ margin: "3px" }}>
            <h5 style={{ marginBottom: 0, marginTop: 10 }}>Operador</h5>
            <h6 style={{ marginBottom: 0 }}>
              {operador.nombre_completo ? operador.nombre_completo : ""}{" "}
              {operador.telefono ? (
                <a
                  href={`tel: +52 ${operador.telefono}`}
                  className="text-black"
                >
                  {operador.telefono}
                </a>
              ) : (
                ""
              )}
            </h6>
            <table className="table table-hover">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">Evento</th>
                  <th scope="col">Hora</th>
                  <th scope="col">Descripcion</th>
                </tr>
              </thead>
              <tbody>
                {bitacora.map((x, index) => {
                  return (
                    <tr key={index}>
                      <td className="text-center">
                        {x.status ? x.status.nombre : "S/E"}
                      </td>
                      <td>{formatDate(x.bitacora_fecha_hora)}</td>
                      <td>{x.notas || "Sin comentarios"}</td>
                    </tr>
                  );
                })}
              </tbody>
              <caption className="text-center">Bitacora de viaje</caption>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
